import "./Input.scss";
import { useFormContext } from "react-hook-form";
import { findInputError } from "../../../utils/findInputError.tsx";
import { isFormInvalid } from "../../../utils/isFormInvalid.tsx";

const InputError = ({ message }: { message: string }) => {
  return (
    <div className="error" {...framer_error}>
      {message}
    </div>
  );
};

const framer_error = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 10 },
  transition: { duration: 0.2 },
};

const Input = ({
  name,
  //label,
  type,
  id,
  placeholder,
  validation,
  multiline,
  className,
}: {
  name: string;
  //label: string,
  type: string;
  id: string;
  placeholder: string;
  validation: object;
  multiline: boolean;
  className: string;
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const inputErrors = findInputError(errors, name);
  const isInvalid = isFormInvalid(inputErrors);

  return (
    <div className="input">
      {multiline ? (
        <textarea
          id={id}
          className={className}
          placeholder={placeholder}
          {...register(name, validation)}
        ></textarea>
      ) : (
        <input
          id={id}
          type={type}
          className={className}
          placeholder={placeholder}
          {...register(name, validation)}
        />
      )}
      {isInvalid && inputErrors.error && inputErrors.error.message && (
        <InputError message={inputErrors.error.message} />
      )}
    </div>
  );
};

export default Input;
